import * as React from 'react';
import { useShippingMethodSelection } from '../../StepShipping/modules/ShippingMethods/hooks/use-shipping-method-selection.js';
import { useShippingMethodsList } from '../../StepShipping/modules/ShippingMethods/hooks/use-shipping-methods-list.js';

const useSetDefaultShippingMethod = ()=>{
    const { shippingMethodList , reloadShippingMethods , isLoading , error  } = useShippingMethodsList();
    const onError = React.useCallback(()=>{
        reloadShippingMethods();
    }, [
        reloadShippingMethods
    ]);
    const { handleOnShippingMethodSelected  } = useShippingMethodSelection({
        shippingMethodList,
        onError
    });
    const setDefaultShippingMethod = (shippingMethod)=>{
        if (error) {
            console.error('Error loading shipping methods', error);
            return;
        }
        handleOnShippingMethodSelected(shippingMethod);
    };
    return {
        setDefaultShippingMethod,
        areShippingMethodsLoading: isLoading
    };
};

export { useSetDefaultShippingMethod };
//# sourceMappingURL=use-set-default-shipping-method.js.map
